export enum IndicationColumnField {
  IndicationNumber = 'referenceId',
  AccountName = 'customer.name',
  CreatedAt = 'createdAt',
  EffectiveDate = 'effectiveOn',
  Offering = 'offering.insuranceProduct.name',
  IndicationAmount = 'termPremium',
  CreatedBy = 'createdByUser.firstName',
  Menu = 'menu',
}
